import React from 'react';

import goldStar from '../../public/images/gold-star.svg';
import starOutline from '../../public/images/icons/star_grey_outline.svg';

import styles from './Stars.module.scss';

const { 'review-stars': reviewStarsClass } = styles;

const Stars = ({ stars }) => {
  const selectStarImg = placementIdx => (placementIdx < stars ? goldStar : starOutline);
  return (
    <div className={reviewStarsClass}>
      {stars > 0 ? (
        <>
          <img src={selectStarImg(0)} alt="star-one" />
          <img src={selectStarImg(1)} alt="star-two" />
          <img src={selectStarImg(2)} alt="star-three" />
          <img src={selectStarImg(3)} alt="star-four" />
          <img src={selectStarImg(4)} alt="star-five" />
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default Stars;
